import {
    DefaultEntityVendorCodes,
    EntityVendorCodes,
    Service,
    Territory
} from '@amzn/coral_com-amazon-musicpapercontractconfigurationservice';

import { ALL_SERVICE, GLOBAL_TERRITORY } from 'src/constants/context';
import { IVendorCode, IVendorCodeOverride } from 'src/types/IVendor';
import { getDateAndTimestamp } from 'src/util/dateTimeUtil';

export const mapVendorCodes = (vendorCodes: IVendorCode[]) => {
    return vendorCodes.map((vendorCode) => {
        const defaultEntityVendorCodes: DefaultEntityVendorCodes = {
            entityVendorCodeId: vendorCode.isNewVendorCode ? undefined : parseInt(vendorCode.vendorCodeId),
            catalogVendorCode: vendorCode.catalogCode,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            endDate: vendorCode.mappingEnd ? getDateAndTimestamp(vendorCode.mappingEnd)[0]! : undefined,
            royaltyVendorCode: vendorCode.royaltyCode,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            startDate: vendorCode.mappingStart ? getDateAndTimestamp(vendorCode.mappingStart)[0]! : undefined
        };

        return defaultEntityVendorCodes;
    });
};

export const mapVendorCodeOverrides = (
    vendorCodeOverrides: IVendorCodeOverride[],
    services: Service[],
    territories: Territory[]
) => {
    const expandedOverrides = vendorCodeOverrides.reduce((acc, curr) => {
        if (curr.serviceId === ALL_SERVICE.ID) {
            const allServices = services.map((service) => ({
                ...curr,
                serviceId: service.serviceId
            }));
            return [...acc, ...allServices];
        } else if (curr.territoryId === GLOBAL_TERRITORY.ID) {
            const allTerritories = territories.map((territory) => ({
                ...curr,
                territoryId: territory.territoryId
            }));
            return [...acc, ...allTerritories];
        } else {
            return [...acc, curr];
        }
    }, [] as IVendorCodeOverride[]);

    return expandedOverrides.map((vendorCodeOverride) => {
        const entityVendorCodes: EntityVendorCodes = {
            entityVendorCodeId: vendorCodeOverride.isNewVendorCode
                ? undefined
                : parseInt(vendorCodeOverride.vendorCodeId),
            catalogVendorCode: vendorCodeOverride.catalogCode,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            endDate: vendorCodeOverride.mappingEnd ? getDateAndTimestamp(vendorCodeOverride.mappingEnd)[0]! : undefined,
            royaltyVendorCode: vendorCodeOverride.royaltyCode,
            service: vendorCodeOverride.serviceId,
            startDate:
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                vendorCodeOverride.mappingStart ? getDateAndTimestamp(vendorCodeOverride.mappingStart)[0]! : undefined,
            territory: vendorCodeOverride.territoryId
        };

        return entityVendorCodes;
    });
};
